import i18n from '../i18n';

class ReferralPresenter {
  constructor(data) {
    this.email = data.email || null;
    this.name = data.full_name || null;
    this.referral_status = data.referral_status || null;
  }

  getEmail() {
    return this.email;
  }

  getFullName() {
    return this.name;
  }

  getDisplayName() {
    return this.name || this.email || '-';
  }

  getReferralStatus() {
    return this.referral_status;
  }

  getDisplayStatus() {
    const status = this.getReferralStatus();
    if (status === 'upgraded') return i18n.t('referrals.status.upgraded');
    return i18n.t('referrals.status.signed_up');
  }
}

export default ReferralPresenter;



